const initialFilters = {
    searchFilters: {},
    pagination: {
        currentPage: 1,
        pageSize: 10,
    },
    refreshIndex: 0
};


export const initialState = {
    qvs: [],
    voters: [],
    qvVoters: [],
    totalCount: 0,
    selectedQV: null,
    filters: initialFilters,
    isLoading: false,
    indexVisibility: 0,
};


export const reducer = (state, action) => {
    switch (action.type) {
        case "set_loading":
            return { ...state, isLoading: action.payload };
        case "set_index_visibility":
            return { ...state, indexVisibility: action.payload };
        case "set_qv_voters":
            return { ...state, qvVoters: action.payload };
        case "set_all_voters":
            return { ...state, voters: action.payload };
        case "set_items":
            return { ...state, qvs: action.payload.qvs, voters: action.payload.voters };
        case "set_search_filters":
            return { ...state, filters: { ...state.filters, searchFilters: action.payload } };
        case "refresh_list":
            return { ...state, filters: { ...state.filters, refreshIndex: state.filters.refreshIndex + 1 } };
        case "set_table_pagination":
            return { ...state, filters: { ...state.filters, pagination: action.payload } }
        case "open_view":
            return { ...state, selectedQV: action.payload.qv, indexVisibility: action.payload.index };
        case "set_voter_sent":
            const updatedVoters = setVoterSent(state.voters, action.payload);
            return { ...state, voters: updatedVoters };
        default:
            return state;
    }
};


const setVoterSent = (voters, voterId) => {
    const updatedVoters = voters.map((voter) => {
        if (voter.voter_id === voterId) {
            voter.isSent = true;
            return voter;
        }
        else {
            return voter;
        }
    });

    return updatedVoters;
};
